import React from "react";
import CheckBox from "../../../../components/form/Checkbox";
import H from "../../helpEnum";
import { mpartial, noop } from "../../../../utils";
import { isUndefined } from "lodash";
import HelpM from "../Help";

const handleCheck = (onChange, changeArray, oldVal, val) => {
  changeArray(oldVal, val);
  onChange(val);
};

const CroSubheadWithCheck = ({
  meta: { touched, error },
  title,
  disabled,
  changeArray,
  helpEnum,
  tooltipPosition,
  className,
  input: { value, onChange = noop },
}) => (
  <div className={`croSubheadCheck ${className || ""}`}>
    <div className="croSubheadCheck__title">
      <span className="croSubheadCheck__text">{title}</span>
      {!isUndefined(helpEnum) && (
        <HelpM
          helpEnum={helpEnum}
          disabled={disabled}
          tooltipPosition={tooltipPosition}
          style={{ padding: "0" }}
        />
      )}
    </div>
    <div className="croSubheadCheck__right">
      <div
        className={`croSubheadCheck__checks${touched && error ? " croSubheadCheck__checks--error" : ""}`}
      >
        <div className="croSubheadCheck__check-item">
          <span className="croSubheadCheck__label">Ano</span>
          <CheckBox
            value={value === true}
            onChange={mpartial(handleCheck, onChange, changeArray, value, true)}
            disabled={disabled}
            aria-label="Ano zvolte v případě, že došlo ke skutečnostem, které jsou vedeny v § 9 až § 11 zákona o střetu zájmů."
          />
        </div>
        <div className="croSubheadCheck__check-item">
          <span className="croSubheadCheck__label">Ne</span>
          <CheckBox
            value={value === false}
            onChange={mpartial(handleCheck, onChange, changeArray, value, false)}
            disabled={disabled}
            aria-label="Ne zvolte v případě, že nedošlo ke skutečnostem, které jsou vedeny v § 9 až § 11 zákona o střetu zájmů."
          />
        </div>
        {!disabled && (
          <HelpM
              helpEnum={H[`STATEMENT_YES_NO`].r}
              disabled={disabled}
              tooltipPosition={tooltipPosition}
              style={{ padding: "0" }}
          />
        )}
      </div>
    </div>
  </div>
);

export default CroSubheadWithCheck;
